/**
 * Функция для склонения слов в зависимости от числа
 * @param count Количество
 * @param words Массив форм слова ['матч', 'матча', 'матчей']
 * @returns Правильная форма слова
 */
export function declension(
	count: number,
	words: [string, string, string],
): string {
	const absCount = Math.abs(count);
	const cases = [2, 0, 1, 1, 1, 2];
	const index =
		absCount % 100 > 4 && absCount % 100 < 20
			? 2
			: cases[Math.min(absCount % 10, 5)];
	return words[index];
}
